import { BpLink } from '../../../../shared/components/text/link/BpLink'
import React from 'react'

interface AdvertisersCountCellProps {
  sites_count: number
  project_id: number | string
  keyword: string
}

export const AdvertisersCountCell = ({
  sites_count,
  project_id,
  keyword,
}: AdvertisersCountCellProps) => {
  return <BpLink to={`advertisers/${project_id}/${keyword}`}>{sites_count}</BpLink>
}
